import { useParams, useNavigate } from 'react-router-dom';
import usePersona from 'data/firestore/agent/llm/use';
import { CellWrapper } from '../../../columns/styled';
import { ResponderName, SmallSaraAvatar } from './styled';

interface Props {
    value?: string;
}

const PersonaCell = ({ value }: Props) => {
    const { agentId } = useParams();
    const navigate = useNavigate();
    const { data: persona } = usePersona(
        agentId as string,
        value as string,
        {
            disabled: !agentId || !value,
        },
    );

    const handleClick = () => {
        if (agentId && value) {
            navigate(`/${agentId}/llms/${value}`);
        }
    };

    return (
        <CellWrapper>
            <ResponderName onClick={handleClick}>
                <SmallSaraAvatar />
                {persona?.name}
            </ResponderName>
        </CellWrapper>
    );
};

export default PersonaCell;
